<template>
  <div id="app">
      <router-view v-if="isMenuRefersh" />
      <van-icon name="back-top" class="backtop" v-show="showBackToTop" @click="scrollToTop" />
  </div>
</template>

<script>
// import VConsole from "vconsole";
// let vConsole = new VConsole();
import { Toast } from 'vant'
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isMenuRefersh: true,
      flag: '',
      view_width: '',
      _html: '',
      showBackToTop: false,
      scrollY: 0, // 当前滚动距离
      threshold: 800 // px 滚动距离阈值
    }
  },
  create() {
    this.view_width = document.getElementsByTagName('html')[0].getBoundingClientRect().width
    this._html = document.getElementsByTagName('html')[0]
    this._html.style.fontSize = (this.view_width / 750) * 100 + 'px'
  },
  beforeMount() {
    Toast.loading({
      duration: 2000,
      message: '加载中...',
      forbidClick: true
    })
  },
  created(){
    window.addEventListener("scroll", this.handleScroll);
  },
  computed: {
    // 计算属性，返回当前是否应该显示返回顶部按钮
    shouldShowBackToTop() {
      return this.scrollY >= this.threshold; // 假设滚动距离超过 500px 时显示按钮
    }
  },
  watch: {
    // 监听 scrollY 属性的变化，更新 showBackToTop 属性
    scrollY(newValue) {
      this.showBackToTop = this.shouldShowBackToTop;
    }
  },
  mounted() {
    Toast.clear()
    if(!this._isMobile()){
      var get_href = window.location.href;
      var get_indexof = get_href.lastIndexOf("/");
      var get_indexText = get_href.substring(get_indexof + 1);
      var get_htmlBeforeText = get_indexText.indexOf(".html");
      if(get_htmlBeforeText == -1){
        // document.querySelector('html').setAttribute('style', 'font-size:40px!important')
        // document.querySelector('body').setAttribute('style', 'width:750px; margin:0 auto')
        // window.location.href = 'https://jinhs.cc/'
      }
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    //全局刷新事件
    reload() {
      this.isMenuRefersh = false
      this.$nextTick(function() {
        this.isMenuRefersh = true
      })
    },
    handleScroll() {
      this.scrollY = window.scrollY;
    },
    scrollToTop(){
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
  }
}
</script>
<style>
.fiexdTop {
  padding-top: 1.4rem;
}
.van-notify {
  height: 1.5rem !important;
}
[class*='van-hairline']::after {
  border: none;
}
.van-tabbar-item--active {
  color: #fb5b4d !important;
}
.van-radio__icon--checked .van-icon {
  background: #fb5b4d !important;
  border-color: #fb5b4d !important;
}
.van-tabbar--fixed {
  border-top: 1px solid #eaeaea;
}
.backtop{
  background: #fb5b4d;
  position: fixed!important;
  right: 20px;
  bottom: 3rem;
  padding: .28rem;
  border-radius: 50%;
  font-size: .5rem!important;
  color: #fff;
  cursor: pointer;
  z-index: 10;
}
.van-collapse-item__content{
  color: #666;
}
.header-font .van-cell{
  font-size: .48rem;
}
.search-content .van-cell{
  padding-right: 0;
}
.van-cell{
  font-size: 0.45rem;
}
.flex-center{
  display: flex;
  align-items: center;
}
.flex-center i{
  font-size: 0.48rem;
  color: #999;
  margin-left: 0.6rem;
}
.flex-center .van-cell{
  padding-left: .35rem;
}
.flex-center em{
  font-size: 0.55rem;
  color: #999;
  margin-right: 0.5rem;
  display: none;
}
.footer{
	font-size: 14px;
	text-align: center;
	color: #999;
	margin-top: 20px;
}
ins.adsbygoogle{
    display: block;
    text-align: center;
    margin: 20px 25px 0;
    overflow: hidden;
}
ins.adsbygoogle[data-ad-status="unfilled"] {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue